import { FormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import { ReasonsResponse } from '../../services/raiseRequest.services';

export function ReasonSelector({
  reasons,
  selectedReason,
  setSelectedReason,
  setSelectedReasonIndex,
}: {
  reasons: ReasonsResponse[];
  selectedReason: string;
  setSelectedReason: any;
  setSelectedReasonIndex: any;
}) {
  return (
    <>
      <Typography variant="body1" fontWeight={'bold'}>
        Reason
      </Typography>
      <FormControl fullWidth>
        <InputLabel id="select-reason-label">Select Reason</InputLabel>
        <Select
          labelId="select-reason-label"
          id="select-reason"
          value={selectedReason}
          label="Select Reason"
          onChange={(e) => setSelectedReason(e.target.value)}
        >
          {reasons?.map((reason, idx) => {
            return (
              <MenuItem
                onClick={() => setSelectedReasonIndex(idx)}
                key={idx}
                value={reason?.ProblemName}
              >
                <Stack>
                  <Typography>{reason?.ProblemName}</Typography>
                </Stack>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </>
  );
}
